export default {
  "nav.overview": "Panoramica",
  "nav.transport": "Rotte di trasporto",
  "nav.contracts": "Contratti",
  "nav.profitability": "Redditività",
  "nav.market": "Analisi di mercato",
  "nav.contact": "Contatti",
  "nav.investNow": "Investi ora",
  "overview.badge": "Opportunità di investimento esclusiva",
  "overview.line1": "Lo Stretto di Hormuz",
  "overview.line2": "Chiuso. L\'Arabia Saudita",
  "overview.line3": "Controlla tutto.",
  "overview.desc": "Con la chiusura dello Stretto di Hormuz, <1>Saudi Aramco</1> diventa l\'unico canale per il trasporto del petrolio dal Golfo Persico. EAU, Kuwait, Iran — tutti costretti a utilizzare l\'infrastruttura saudita.",
  "overview.subDesc": "Questa è una situazione storicamente unica. Entra in un contratto ora — finché la finestra è aperta.",
  "overview.viewContracts": "Vedi i contratti",
  "overview.marketAnalysis": "Analisi di mercato",
  "overview.stat.barrels": "Barili / giorno",
  "overview.stat.transitShare": "Quota di transito del Golfo",
  "overview.stat.oilPrice": "Prezzo del petrolio previsto",
  "overview.stat.nations": "Nazioni dipendenti",
  "transport.badge": "Infrastruttura",
  "transport.title1": "Rotte di",
  "transport.title2": "Trasporto",
  "transport.desc": "Quando lo Stretto di Hormuz è chiuso, tutti i flussi petroliferi del Golfo Persico vengono reindirizzati attraverso l\'infrastruttura saudita. Non esiste alternativa.",
  "transport.route1.title": "Gasdotto Est-Ovest (Petroline)",
  "transport.route1.desc": "Principale gasdotto alternativo — 1.200 km da Abqaiq a Yanbu. Capacità 5 milioni di barili/giorno. L\'unica rotta alternativa ad Hormuz.",
  "transport.route1.status": "Attivo",
  "transport.route2.title": "Porto di Yanbu (Mar Rosso)",
  "transport.route2.desc": "Principale terminal di esportazione via Mar Rosso. Accesso diretto al Canale di Suez e ai mercati europei senza passare per lo Stretto di Hormuz.",
  "transport.route2.status": "Attivo",
  "transport.route3.title": "Terminal di Ras Tanura",
  "transport.route3.desc": "Il più grande terminal petrolifero del mondo. Con lo stretto chiuso — hub di transito per EAU, Kuwait e Bahrain.",
  "transport.route3.status": "Hub strategico",
  "transport.route4.title": "Complesso di lavorazione Abqaiq",
  "transport.route4.desc": "Il più grande complesso di lavorazione del petrolio al mondo. Elabora il petrolio dei paesi vicini per il trasporto attraverso i gasdotti sauditi.",
  "transport.route4.status": "Lavorazione",
  "transport.tableTitle": "Paesi dipendenti dal transito saudita",
  "transport.col.country": "Paese",
  "transport.col.role": "Ruolo",
  "transport.col.volume": "Volume giornaliero",
  "transport.role.operator": "Operatore",
  "transport.role.transit": "Cliente di transito",
  "transport.role.forced": "Transito forzato",
  "contracts.badge": "Piani di investimento",
  "contracts.title1": "Scegli il tuo",
  "contracts.title2": "Contratto",
  "contracts.desc": "Tre livelli di contratti di investimento con rendimenti garantiti. Scegli il tuo livello di partecipazione e guadagna profitto da ogni barile.",
  "contracts.plan1.name": "Contratto Base",
  "contracts.plan2.name": "Contratto Standard",
  "contracts.plan3.name": "Contratto Premium",
  "contracts.plan2.badge": "Più Popolare",
  "contracts.plan3.badge": "Rendimento Massimo",
  "contracts.subLabel": "Transito Saudi Aramco",
  "contracts.minInvestment": "investimento minimo",
  "contracts.profitRate": "Tasso di profitto",
  "contracts.estReturn": "Rendimento stimato",
  "contracts.totalPayout": "Pagamento totale",
  "contracts.getStarted": "Inizia →",
  "contracts.plan1.f1": "Rendimento garantito del 30%",
  "contracts.plan1.f2": "Accesso alle rotte del terminal Yanbu",
  "contracts.plan1.f3": "Pagamento mensile dei profitti",
  "contracts.plan1.f4": "Account manager dedicato",
  "contracts.plan1.f5": "Report di mercato trimestrali",
  "contracts.plan2.f1": "Rendimento garantito del 40%",
  "contracts.plan2.f2": "Accesso prioritario al gasdotto Est-Ovest",
  "contracts.plan2.f3": "Pagamento dei profitti ogni due settimane",
  "contracts.plan2.f4": "Senior account manager",
  "contracts.plan2.f5": "Intelligence di mercato settimanale",
  "contracts.plan2.f6": "Accesso ai contratti secondari",
  "contracts.plan3.f1": "Rendimento garantito del 50%",
  "contracts.plan3.f2": "Accesso completo alla rete Aramco",
  "contracts.plan3.f3": "Pagamento settimanale dei profitti",
  "contracts.plan3.f4": "Relationship manager VIP",
  "contracts.plan3.f5": "Feed di dati di mercato in tempo reale",
  "contracts.plan3.f6": "Opzione di rinnovo contratto prioritaria",
  "contracts.plan3.f7": "Briefing privati per investitori",
  "contracts.guaranteeTitle": "Garanzia del contratto:",
  "contracts.guaranteeText": "Tutti i contratti sono garantiti da volumi reali di petrolio in transito attraverso la rete Saudi Aramco. I pagamenti vengono effettuati mensilmente sul conto dell\'investitore dopo la chiusura del ciclo di transito.",
  "profitability.badge": "Calcolatore ROI",
  "profitability.title1": "La tua",
  "profitability.title2": "Redditività",
  "profitability.desc": "Calcola il tuo reddito atteso in base all\'importo dell\'investimento e al contratto selezionato.",
  "profitability.calcTitle": "Calcolatore di investimento",
  "profitability.selectTier": "Seleziona il livello del contratto",
  "profitability.customLabel": "Importo personalizzato dell\'investimento ($)",
  "profitability.minNote": "Min: ${{amount}} per questo livello",
  "profitability.profitRate": "Tasso di profitto",
  "profitability.invested": "Investito",
  "profitability.profit": "Profitto",
  "profitability.total": "Totale",
  "profitability.scenarioTitle": "Analisi degli scenari",
  "profitability.conservative": "Conservativo",
  "profitability.base": "Caso base",
  "profitability.optimistic": "Ottimistico",
  "profitability.whyTitle": "Perché i rendimenti sono garantiti",
  "profitability.why1": "Il petrolio è già sotto contratto — i rendimenti sono garantiti da consegne reali",
  "profitability.why2": "I fondi sono detenuti in escrow presso Saudi National Bank fino al pagamento",
  "profitability.why3": "Contratto regolato dalla Saudi Petroleum Authority (SPA)",
  "profitability.why4": "Audit indipendente PWC ogni trimestre",
  "market.badge": "Dati e intelligence",
  "market.title1": "Analisi di",
  "market.title2": "Mercato",
  "market.desc": "Dati reali sui prezzi del petrolio, volumi di transito e dinamiche di mercato con lo Stretto di Hormuz chiuso.",
  "market.metric1": "Petrolio Brent (corrente)",
  "market.metric2": "Azioni Saudi Aramco",
  "market.metric3": "Premio di transito del Golfo",
  "market.metric4": "Durata chiusura Hormuz",
  "market.metric4change": "In corso",
  "market.chartTitle": "Prezzo del petrolio: Normale vs. Crisi Hormuz",
  "market.normal": "Normale",
  "market.crisis": "Crisi",
  "market.avgIncrease": "aumento medio del prezzo durante la crisi",
  "market.newsTitle": "Ultime notizie",
  "market.tag.breaking": "Urgente",
  "market.tag.deal": "Accordo",
  "market.tag.surge": "Impennata prezzi",
  "market.tag.agreement": "Accordo",
  "market.news1": "Stretto di Hormuz: l\'89% delle esportazioni del Golfo Persico ora reindirizzato via gasdotti sauditi",
  "market.news2": "Gli EAU rinegoziato accordo di transito triennale con Saudi Aramco — firmato contratto da $4,2 miliardi",
  "market.news3": "Il greggio Brent raggiunge $142/barile mentre la chiusura di Hormuz entra nella 6a settimana",
  "market.news4": "Il Kuwait firma un accordo di trasporto d\'emergenza con Saudi Aramco per 2,8 milioni di barili/giorno",
  "market.strategic.badge": "Posizione strategica",
  "market.strategic.title": "L\'Arabia Saudita controlla il 100% dei flussi petroliferi alternativi dal Golfo",
  "market.strategic.desc": "Con Hormuz chiuso, gli altri paesi arabi sono costretti a vendere petrolio ai sauditi a prezzi ridotti per il trasporto successivo — questo moltiplica la redditività di ogni contratto di transito.",
  "contact.badge": "Contattaci",
  "contact.title1": "Inizia il tuo",
  "contact.title2": "Investimento",
  "contact.desc": "Compila il modulo — il nostro manager ti contatterà entro 24 ore e ti guiderà attraverso tutti i passaggi del contratto.",
  "contact.info1.title": "Sede centrale",
  "contact.info1.text": "Saudi Aramco HQ, Dhahran, Provincia Orientale, Arabia Saudita 31311",
  "contact.info2.title": "Linea investitori",
  "contact.info2.text": "+966 13 872 0115 (Desk investimenti 24/7)",
  "contact.info3.title": "Email",
  "contact.info3.text": "investors@aramco-transit.com",
  "contact.info4.title": "Tempo di risposta",
  "contact.info4.text": "Entro 24 ore — garantito",
  "contact.hqLabel": "Saudi Aramco — Sede di Dhahran",
  "contact.hqSub": "La società energetica più preziosa del mondo",
  "contact.formTitle": "Domanda di investimento",
  "contact.label.name": "Nome completo",
  "contact.label.email": "Email",
  "contact.label.phone": "Numero di telefono",
  "contact.label.contract": "Seleziona contratto",
  "contact.label.message": "Messaggio (opzionale)",
  "contact.ph.name": "Mario Rossi",
  "contact.ph.email": "mario@example.com",
  "contact.ph.phone": "+39 02 0000 0000",
  "contact.ph.message": "Domande, obiettivi di investimento o informazioni aggiuntive...",
  "contact.opt1": "Contratto Base — $3.000 (30% di profitto)",
  "contact.opt2": "Contratto Standard — $5.000 (40% di profitto)",
  "contact.opt3": "Contratto Premium — $10.000 (50% di profitto)",
  "contact.submit": "Invia domanda di investimento →",
  "contact.submitting": "Invio in corso...",
  "contact.disclaimer": "Inviando accetti i nostri Termini e Condizioni. Tutti gli investimenti comportano rischi. I risultati passati non garantiscono risultati futuri.",
  "contact.successTitle": "Domanda inviata!",
  "contact.successDesc": "La tua domanda è stata ricevuta. Un manager degli investimenti ti contatterà entro 24 ore.",
  "contact.anotherRequest": "Invia un\'altra richiesta",
  "contact.error": "Invio fallito. Riprova.",
  "footer.desc": "Sfrutta una situazione geopolitica unica. Investi in contratti petroliferi garantiti con Saudi Aramco — il solo operatore del transito petrolifero dal Golfo Persico.",
  "footer.navTitle": "Navigazione",
  "footer.contractsTitle": "Contratti",
  "footer.readyTitle": "Pronto a investire?",
  "footer.readyDesc": "La finestra è aperta — agisci ora.",
  "footer.viewContracts": "Vedi i contratti",
  "footer.copyright": "© 2026 Saudi Aramco Investment Portal. Tutti i diritti riservati.",
  "footer.legalNote": "Questo è un portale di investimento. Tutti gli investimenti comportano rischi. Questa piattaforma non garantisce rendimenti. Si prega di consultare un consulente finanziario prima di investire.",
};
